var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FeedWrapper',{attrs:{"has-items":_vm.feed.length !== 0,"all-loaded":_vm.allLoaded}},[_vm._l((_vm.feed),function(item){return _vm._t("default",null,null,item)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }